import React from 'react'
import { Image, ImageBase, ImageOptions } from '../../utils/image'
import { Link } from '../../utils/link'

export type GridLinkItem = {
  title: string
  intro: string
  url?: string
  image?: ImageBase & ImageOptions
}

export const GridLinkItemLayout = (p: GridLinkItem) => (
  <article className="grid__link-article">
    {p.url ? (
      <Link url={p.url} className={'grid__link-container'}>
        <div className={'grid__link-visual grid__visual container fit-object'}>
          {p.image && (
            <Image
              {...p.image}
              classNames={{ image: 'grid__image card-img-top' }}
              width="392"
              height="196"
              lazyload={true}
              src={p.image.src}
            />
          )}
        </div>

        <div className="grid__link-inner">
          <div className="grid__link-inner-container">
            <header>
              <h3 className="grid__link-title">{p.title}</h3>
            </header>
            <p className="grid__link-intro">{p.intro}</p>
            <footer className="grid__link-readMore">{p.url && <p>Lees meer</p>}</footer>
          </div>
        </div>
      </Link>
    ) : (
      <div>
        <div className={'grid__link-visual grid__visual container fit-object'}>
          {p.image && (
            <Image
              {...p.image}
              classNames={{ image: 'grid__image card-img-top' }}
              width="392"
              height="196"
              lazyload={true}
              src={p.image.src}
            />
          )}
        </div>

        <div className="grid__link-inner">
          <div className="grid__link-inner-container">
            <header>
              <h3 className="grid__link-title">{p.title}</h3>
            </header>
            <p className="grid__link-intro">{p.intro}</p>
          </div>
        </div>
      </div>
    )}
  </article>
)
